export const CORAL_THREAD_ID = 'coral_thread';
export const CORAL_URL = 'https://ctm-talk.is.hubs.vn';
